import moment from 'moment'
export const monthToDay = (month) => {
    switch (month) {
        case 1:
            return 31;
        case 2:
            return 27;
        case 3:
            return 31;
        case 4:
            return 30;
        case 5:
            return 31;
        case 6:
            return 30;
        case 7:
            return 31;
        case 8:
            return 31;
        case 9:
            return 30;
        case 10:
            return 31;
        case 11:
            return 30;
        case 12:
            return 31;
        default:
            return 30;
    }
}
export const returnTrainingTimeModeTime = (timeMode) => {
    switch (timeMode) {
        case "":
            return { startTime: "", endTime: "" };
        case "oneWeek":
            return returnNowOneWeek();
        case "oneMonth":
            return returnNowOneMonth();
        case "threeMonth":
            return returnNowThreeMonth();
        case "halfYear":
            return returnNowHalfYear();
        case "oneYear":
            return returnNowOneYear();
        default:
            return undefined;
    }
}

export const returnNowWeek = (num) => {
    let returnTime = {};
    returnTime.endTime = moment().format('YYYY-MM-DDTHH:mm:ss');
    returnTime.startTime = moment().subtract(num, 'weeks').format('YYYY-MM-DDTHH:mm:ss');
    return returnTime;
}

export const returnNowOneWeek = () => {
    return returnNowWeek(1);
}

export const returnNowMonth = (num) => {
    let returnTime = {};
    returnTime.endTime = moment().format('YYYY-MM-DDTHH:mm:ss');
    returnTime.startTime = moment().subtract(num, 'months').format('YYYY-MM-DDTHH:mm:ss');
    return returnTime;
}

export const returnNowOneMonth = () => {
    return returnNowMonth(1);
}
export const returnNowThreeMonth = () => {
    return returnNowMonth(3);
}
export const returnNowHalfYear = () => {
    return returnNowMonth(6);
}

export const returnNowYear = (num) => {
    let returnTime = {};
    returnTime.endTime = moment().format('YYYY-MM-DDTHH:mm:ss');
    returnTime.startTime = moment().subtract(num, 'years').format('YYYY-MM-DDTHH:mm:ss');
    return returnTime;
}
export const returnNowOneYear = () => {
    return returnNowYear(1);
}


export const returnQueryBySearchShareFile = (page, limitCount, keyWord, fromTime, endTime, checkedOptions,sort) => {
    let query = "?";
    let queryFlag = true;
    if (keyWord !== "" && keyWord) {
        query += "keyWord=" + keyWord;
        queryFlag = false;
    }

    if (queryFlag && fromTime && fromTime !== "") {
        query += "fromTime=" + fromTime;
        queryFlag = false;
    }
    else if (fromTime && fromTime !== "") {
        query += "&fromTime=" + fromTime;
    }

    if (queryFlag && endTime && endTime !== "") {
        query += "endTime=" + endTime;
        queryFlag = false;
    }
    else if (endTime && endTime !== "") {
        query += "&endTime=" + endTime;
    }

    if (queryFlag && checkedOptions && checkedOptions.length !== 0) {
        query += "type=" + checkedOptions;
        queryFlag = false;
    }
    else if (checkedOptions !== 0) {
        query += "&type=" + checkedOptions;
    }

    if (queryFlag && sort && sort !== "" ) {
        query += "sort=" + sort;
        queryFlag = false;
    }
    else if (sort !== "") {
        query += "&sort=" + sort;
    }

    if (queryFlag) {
        query += "limit=" + limitCount + "&page=" + page;
    }
    else {
        query += "&limit=" + limitCount + "&page=" + page;
    }

    return query;
}